import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface Instance {
  id: string;
  hostname: string;
  region: string;
  started_at: number;
  last_heartbeat: number;
  status: string;
  active_task_count: number;
}

interface InstancesState {
  instances: Instance[];
  loading: boolean;
  error: string | null;
      stats: {
        activeCount: number;
        totalCount: number;
        totalActiveTaskCount: number;
      };
  lastFetchTime: number | null;
  cacheDuration: number;
  setInstances: (instances: Instance[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setStats: (stats: Partial<InstancesState['stats']>) => void;
  isCacheValid: () => boolean;
  invalidateCache: () => void;
}

export const useInstancesStore = create<InstancesState>()(
  persist(
    (set, get) => ({
      instances: [],
      loading: false,
      error: null,
      stats: {
        activeCount: 0,
        totalCount: 0,
        totalActiveTaskCount: 0,
      },
      lastFetchTime: null,
      cacheDuration: 5 * 60 * 1000, // 5 minutes cache

      setInstances: (instances) => set({ instances, lastFetchTime: Date.now() }),

      setLoading: (loading) => set({ loading }),

      setError: (error) => set({ error }),

      setStats: (stats) =>
        set((state) => ({
          stats: { ...state.stats, ...stats },
        })),

      isCacheValid: () => {
        const { lastFetchTime, cacheDuration } = get();
        if (!lastFetchTime) return false;
        return Date.now() - lastFetchTime < cacheDuration;
      },

      invalidateCache: () => set({ instances: [], lastFetchTime: null }),
    }),
    {
      name: 'instances-storage',
      partialize: (state) => ({
        instances: state.instances,
        stats: state.stats,
        lastFetchTime: state.lastFetchTime,
      }),
    }
  )
);
